import { motion } from "framer-motion";
import { Layers } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 48 — Bridge / re-anchor: "This is built entirely from content we already have."
 * Sits between the amplification chain and the strategic positioning · simple, calm, declarative.
 */

export default function Scene48_BuiltFromContent() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-built-from-content">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(212,148,10,0.10) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.20) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(212,148,10,0.10) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mx-auto flex items-center justify-center gap-2"
        >
          <Layers className="w-3.5 h-3.5" style={{ color: "#e9a820" }} />
          The unfair advantage
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 kn-display text-4xl sm:text-6xl lg:text-7xl text-white leading-[1.05]"
          data-testid="built-from-content-headline"
        >
          Built{" "}
          <span style={{ color: "#e9a820", fontWeight: 800 }}>entirely</span>
          <br />
          from content we{" "}
          <span
            style={{
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              fontWeight: 900,
            }}
          >
            already have.
          </span>
        </motion.h2>
      </div>
    </SceneShell>
  );
}
